import React from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components';
import NeedContext from '../NeedContext';

const ActionButtons: React.FC = () => {
  const { needId } = useParams<Record<string, string>>();
  const { deleteNeed, isAuthorizedToEdit } = React.useContext(NeedContext);

  if (!isAuthorizedToEdit) return null;

  return (
    <StyledWrapper>
      <Button onClick={deleteNeed} danger>
        Delete
      </Button>
      <Link to={`/needs/${needId}/upload`}>
        <Button>Manage Photos/Files</Button>
      </Link>
      <Link to={`/needs/${needId}/edit`}>
        <Button>Edit</Button>
      </Link>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  > * {
    margin-left: 10px;
  }
`;

export default ActionButtons;
